<template>
  <div class="playingCardComponent">
    <div v-if="largeFont">
      <img :src="svgSrc" :style="style" />
    </div>
    <VuePlayingCard
      v-else
      :width="width"
      :height="height"
      :signature="cardString"
      :key="cardString"
    />
  </div>
</template>

<script>
import { VuePlayingCard } from "vue-playing-card";

export default {
  components: { VuePlayingCard },
  props: {
    cardString: { type: String, required: true },
    largeFont: { type: Boolean, default: true },
    height: Number,
    width: Number,
  },
  computed: {
    svgSrc() {
      const file = `${this.cardString.toUpperCase()}.svg`;
      return `/cards_svg/${file}`;
    },
    style() {
      const style = {};
      if (this.height) style.height = `${this.height}px`;
      if (this.width) style.width = `${this.width}px`;
      return style;
    },
  },
};
</script>

<style lang="scss" scoped>
.playingCardComponent {
  display: inline-block;
}
</style>
